import type { AxiosError } from 'axios';

const filterNullAndUndefined = (value: Record<string, any>) =>
  Object.keys(value ?? {})
    .filter((key) => value[key] !== null && value[key] !== undefined)
    .reduce((acc, key) => {
      acc[key] = value[key];
      return acc;
    }, {} as any);

export const getUrlFromAxiosError = (error: AxiosError) => {
  // Explicitly not filtering for boolean here, we want to keep those as those are explicitly set
  const paramsFiltered = filterNullAndUndefined(error?.config?.params);
  const paramsString = new URLSearchParams(paramsFiltered).toString();

  // Decoding just to have more human-friendly URLs in our logs
  const paramsDecoded = decodeURIComponent(paramsString);

  return `${error?.config?.url}${paramsDecoded}`;
};
